import { Model } from 'infra/model'
import { JobEventDTO, JobEventType, JobEventVisibility } from './dtos/job-event'
import { observable, makeObservable } from 'mobx'
import Job from './Job'
import Member from 'iam/models/Member'
import { DateZero, maybeParseDate } from 'utils/date-util'
import { PrimeMember } from 'iam/MemberStore'
import { Id } from 'types/definitions'

export default class JobEvent extends Model<JobEventDTO, JobEvent> {
  job: Job
  id = Id.none

  @observable eventType: JobEventType = 'UPDATED'
  @observable eventVisibility: JobEventVisibility = 'INTERNAL'
  @observable description = ''
  @observable dateCreated: Date = DateZero()
  @observable triggeredBy: Member = Member.none
  @observable reason = ''
  @observable taskTitle?: string = undefined
  @observable previousProvider?: string = undefined
  @observable newTeam?: string = undefined
  @observable jobResolution?: 'DONE' | 'CANCELLED' | 'TEST' = undefined
  @observable newProvider?: string = undefined
  @observable newClient?: string = undefined
  @observable provider?: string = undefined

  constructor(
    job: Job | undefined,
    private primeMember: PrimeMember,
  ) {
    super()
    makeObservable(this)
    if (!job) {
      throw new Error(
        'Attempted to instantiate a Job Event with an undefined Job.',
      )
    }
    this.job = job
  }

  parse(attrs: Partial<JobEventDTO>): Partial<JobEvent> {
    return {
      id: attrs.id,
      eventType: attrs.event_type,
      description: attrs.description,
      reason: attrs.reason || '',
      dateCreated: maybeParseDate(attrs.date_created),
      triggeredBy:
        attrs.triggered_by &&
        this.primeMember({
          user_id: attrs.triggered_by.user_id,
          user_public_id: attrs.triggered_by.user_public_id,
          workspace_id: this.job.workspace.id,
          given_name: attrs.triggered_by.first_name,
          family_name: attrs.triggered_by.last_name,
        }),
      taskTitle: attrs.task_title,
      previousProvider: attrs.previous_provider?.display_name,
      newTeam: attrs.new_team?.name,
      jobResolution: attrs.job_resolution?.resolution,
      provider: attrs.provider?.display_name,
      newProvider: attrs.new_provider?.display_name,
      newClient: attrs.new_client?.display_name,
    }
  }
}
